import { ITripServiceDto } from '../../service-type-dto.interface';

export interface IUpdateTripInput {
    id: string;
    scheduledStart?: string | null;
    vehicleId?: string | null;
    driverId?: string | null;
    companionId?: string | null;
    carrierId?: string | null;
    semitrailerIds?: string[] | null;
    accounts?: string[];
    tags?: string[];
    rateId?: string | null;
    services?: ITripServiceDto[] | null;
    checkpoints?: {
        type?: string;
        locationId: string;
        isStopover?: boolean;
        duration?: string;
        accountId?: string | null;
        plannedAt?: string | null;
        created?: boolean;
        updated?: boolean;
        deleted?: boolean;
        unitChange?: {
            carrierId?: string;
            vehicleId?: string;
            driverId?: string;
            semitrailerIds?: string[];
        };
    }[];
}
